<template>
    <div class="modal" id="confirm_modal">
        <div class="modal-dialog">
            <div class="modal-content shadow-3">
                <div class="modal-header">
                    <h4 class="modal-title">
                        {{ title }}
                    </h4>
                </div>
                <div class="modal-body" v-if="Object.values(this.$slots).length > 0">
                    <slot />
                </div>
                <div class="modal-body" v-html="body" v-else />
                <div class="modal-footer">
                    <button class="btn btn-sm btn-neutral" @click="close">
                        {{ translate('__JSON__.Cancel') }}
                    </button>
                    <button :class="`btn btn-sm btn-${variant}`" v-for="({ label, variant, onClick }) in buttons" @click="onClick">
                        {{ label }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { trans } from '../../bootstrap'

export default {
    name: 'ConfirmModal',
    props: {
        title: {
            type: String,
            required: true,
        },
        body: {
            type: String,
            required: true,
        },
        buttons: {
            type: Object,
            required: true,
        },
        parentModalId: {
            type: String,
            required: true,
        },
    },
    methods: {
        translate(pointer) {
            return trans.get(pointer)
        },
        async close() {
            await window.bootstrap.Modal.getOrCreateInstance(document.getElementById('confirm_modal')).hide()
            document.getElementById(this.parentModalId).style.display = 'block'
        },
    },
}
</script>
